import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'

import goTo from 'vuetify/lib/services/goto'

import store from '@/store'

// Pages.
import Category from '@/views/Category.vue'
import Collection from '@/views/Collection.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import Home from '@/views/Home.vue'
import Library from '@/views/Library.vue'
import Login from '@/views/Login.vue'
import Reader from '@/views/Reader.vue'

Vue.use(VueRouter)

const routes = [
  {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        onlyNotLogged: true
      }
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    meta: {
      onlyLogged: true
    },
    children: [
        {
            path: 'home',
            name: 'home',
            component: Home
        },
        {
            path: 'category/:slug',
            name: 'category',
            component: Category
        },
        {
            path: 'collection/:slug',
            name: 'collection',
            component: Collection
        },
        {
            path: 'library/:slug',
            name: 'library',
            component: Library
        },
        {
            path: ':modelType/:slug/reader',
            name: 'reader',
            component: Reader
        },
        {
            path: 'error',
            name: 'error',
            component: ErrorPage
        }
      ]
  }
]

const scrollBehavior = (to)=>{
    if (to.hash)
        return goTo(to.hash)
    
    return goTo(0)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
})

router.afterEach((/*to, from*/) => {
  // mostro il footer perché in alcune pagine potrei averlo disattivato
  store.commit('ui/showFooter')
})

/**
 * 🔒 Auth Gateway.
 */
router.beforeEach((to, from, next) => {

  const loggedIn = localStorage.getItem('user')

  // auth check
  if (to.matched.some(record => record.meta.onlyLogged) && !loggedIn) {
    next('/login')
    return
  }

  if (to.matched.some(record => record.meta.onlyNotLogged) && loggedIn) {
    next('/home')
    return
  }

  next()

})


/**
router.beforeEach((to, from, next) => {
  
  const //authUser = store.getters["auth/authUser"],
        authUser = localStorage.getItem('user'),
        reqAuth = to.matched.some((record) => record.meta.onlyLogged),
        loginQuery = { path: "/login", query: { redirect: to.fullPath } }

        console.log(reqAuth, authUser)

  if (reqAuth && !authUser) {
    
    store.dispatch("auth/getAuthUser").then(() => {
      if (!store.getters["auth/authUser"]) next(loginQuery);
      else next();
    })

  } else {
    
    next()
  }

});
*/

export default router